import React from 'react'
import styles from './styles'
import check from '~/images/icons/check.svg';

export const Advantages = () => {
  const classes = styles();
  return (
    <div className={classes.mainContainer}>
      <div className={classes.itemsContainer}>
          <div className={classes.item}>
            <AdvantagesItem text="Comprehensive consultations with our representatives"/>
            <AdvantagesItem text="24/7 customer service"/>
            <AdvantagesItem text="Training and product updates"/>
            <AdvantagesItem text="Online portal for case tracking"/>
          </div>
          <div className={classes.item}>
            <AdvantagesItem text="Customized plans with objectives set by the practice"/>
            <AdvantagesItem text="Marketing support"/>
            <AdvantagesItem text="Custom packaging"/>
            <AdvantagesItem text="Educational material for doctors and patients"/>
          </div>
      </div>
    </div>
  );
}


function AdvantagesItem({text}: {text: string}){
  const classes = styles();
  return (
    <div className={classes.advantageContainer}>
      <img src={check} alt="check" className={classes.icon}/>
      <span className={classes.advantageText}>{text}</span>
    </div>
  )
}